import type en from "./en"

const nn: typeof en = {
  "add-user.invite-users": "NEEDS TRANSLATION",
  "add-users.add-more-users": "NEEDS TRANSLATION",
  "add-users.send-invite": "NEEDS TRANSLATION",
  "add-users.toasts.success": "NEEDS TRANSLATION",
  "admin-required.message": "Du må være administrator for å se dette.",
  "auth.admin-or-user-required":
    "Du må være {user} eller en administrator for å se dette",
  "auth.goodbye": "NEEDS TRANSLATION",
  "auth.sign-out": "NEEDS TRANSLATION",
  "billing-methods.ehf": "NEEDS TRANSLATION",
  "billing-methods.labels.ehf": "NEEDS TRANSLATION",
  "buy-new-subscription.title": "NEEDS TRANSLATION",
  "cancel-subscription-success.contact-form": "NEEDS TRANSLATION",
  "cancel-subscription-success.description": "NEEDS TRANSLATION",
  "cancel-subscription-success.title": "NEEDS TRANSLATION",
  "cancel-subscription-success.toast-text": "NEEDS TRANSLATION",
  "cancel-subscription.confirm-cancel": "NEEDS TRANSLATION",
  "cancel-subscription.keep-subscription": "NEEDS TRANSLATION",
  "cancel-subscription.subtitle": "NEEDS TRANSLATION",
  "cancel-subscription.title": "NEEDS TRANSLATION",
  "change-password.description":
    "Av sikkerhetsgrunner må du bytte passordet ditt før du logger inn på nytt.",
  "change-password.title": "Bytt passord",
  "change-payment-method-success.title": "NEEDS TRANSLATION",
  "change-payment-method-success.toast": "NEEDS TRANSLATION",
  "change-payment-method.submit-text": "NEEDS TRANSLATION",
  "change-payment-method.title": "NEEDS TRANSLATION",
  "change-periodicity.save-success": "NEEDS TRANSLATION",
  "common.absence": "Fravær",
  "common.absences": "Fravær",
  "common.activate": "NEEDS TRANSLATION",
  "common.active": "NEEDS TRANSLATION",
  "common.activities": "Aktiviteter",
  "common.activity": "Aktivitet",
  "common.add": "Legg til",
  "common.add-file": "Legg ved fil",
  "common.add-files": "Legg ved filer",
  "common.address": "Adresse",
  "common.age": "Alder",
  "common.all": "Alle",
  "common.app": "App",
  "common.archive": "Arkivér",
  "common.author": "Forfatter",
  "common.availability":
    "{abbreviate, select, true {Tilgj.} other {Tilgjengelighet}}",
  "common.back": "NEEDS TRANSLATION",
  "common.business": "Firma",
  "common.businessOverview": "Firmaoversikt",
  "common.cancel": "Avbryt",
  "common.cancel-changes": "Angre Endringer",
  "common.category": "Kategori",
  "common.change-organization": "Bytt firma",
  "common.city": "By",
  "common.clear": "NEEDS TRANSLATION",
  "common.close": "Lukk",
  "common.closed": "Lukket",
  "common.codes": "Koder",
  "common.contact-info": "Kontaktinfo",
  "common.contact-person": "Kontaktperson",
  "common.content": "Innhold",
  "common.country": "Land",
  "common.create": "Opprett ny",
  "common.create-entry": "Lag nytt innlegg",
  "common.create-folder": "Lag ny mappe",
  "common.create-worksheet": "Opprett arbeidsark",
  "common.creating": "Oppretter",
  "common.current-password": "Nåværende passord",
  "common.dashboard": "Kontrollpanel",
  "common.date": "Dato",
  "common.date-validation-not-in-future":
    "Dato må være gyldig og ikke i fremtiden",
  "common.day-end": "Dag slutt",
  "common.day-start": "Dag start",
  "common.days": "{days, plural, =0 {Ingen dager} one {# dag} other {# dager}}",
  "common.deactivate": "NEEDS TRANSLATION",
  "common.delete": "Slette",
  "common.delete-alt": "Slett",
  "common.delete-type": "Slett {type}",
  "common.description": "Beskrivelse",
  "common.detail": "Detalje",
  "common.distance": "Distanse",
  "common.document": "Dokument",
  "common.documentation": "Dokumentasjon",
  "common.documentationIssues": "Dokumentasjonsavvik",
  "common.documents": "Dokumenter",
  "common.download": "NEEDS TRANSLATION",
  "common.driver": "Sjåfør",
  "common.drivers": "Sjåfører",
  "common.drivers-handbook": "Sjåførhåndbok",
  "common.driversHandbook": "Sjåførhåndbok",
  "common.driving": "Kjøring",
  "common.driving-data": "Kjøredata",
  "common.dropdown": "Nedtrekksmeny",
  "common.dropdown-on-pages": "Bruker dropdown på side",
  "common.edit": "Endre",
  "common.edit-alt": "Redigér",
  "common.edit-type": "Redigér {type}",
  "common.ehf": "NEEDS TRANSLATION",
  "common.electronic-invoicing": "NEEDS TRANSLATION",
  "common.email": "E-post",
  "common.email-taken": "E-posten er opptatt",
  "common.employee": "Ansatt",
  "common.end": "Slutt",
  "common.english": "Engelsk",
  "common.entry": "Innlegg",
  "common.eurovignette": "Eurovignette",
  "common.eurovignettes": "Eurovignettes",
  "common.expired": "Utløpt",
  "common.favourite": "NEEDS TRANSLATION",
  "common.favourites": "Favoritter",
  "common.files": "Filer",
  "common.filter": "Filter",
  "common.first-grade": "NEEDS TRANSLATION",
  "common.first-name": "Fornavn",
  "common.folder": "Mappe",
  "common.forum": "Forum",
  "common.gender": "Kjønn",
  "common.general": "Generelt",
  "common.handbook": "Håndbok",
  "common.home": "Hjem",
  "common.hourlist": "Timeliste",
  "common.hours": "Timer",
  "common.hours-lowercase": "timer",
  "common.in-app": "I app",
  "common.inactive": "NEEDS TRANSLATION",
  "common.information": "Informasjon",
  "common.invoicing": "NEEDS TRANSLATION",
  "common.issue": "Avvik",
  "common.issues": "Avvik",
  "common.km": "km",
  "common.language": "Språk",
  "common.last-name": "Etternavn",
  "common.liters-short": "l",
  "common.loading": "Laster",
  "common.loading...": "Laster inn...",
  "common.log-in": "Logg in",
  "common.log-out": "Logg ut",
  "common.login": "Login",
  "common.mathematics": "Matematikk",
  "common.month": "Måned",
  "common.monthly": "NEEDS TRANSLATION",
  "common.multiple": "NEEDS TRANSLATION",
  "common.my-worksheets": "Mine arbeidsark",
  "common.name": "Navn",
  "common.new-password": "Nytt passord",
  "common.new-password-again": "Gjenta nytt passord",
  "common.new-password-sent": "Nytt passord er sendt på mail!",
  "common.new-worksheet": "NEEDS TRANSLATION",
  "common.try-new-generator": "Ny generator",
  "common.try-new-generator-beta": "Beta",
  "common.next": "NEEDS TRANSLATION",
  "common.no": "Nei",
  "common.norwegian": "Norsk",
  "common.notification": "Varsling",
  "common.nth-grade": "NEEDS TRANSLATION",
  "common.office": "Kontor",
  "common.ok": "OK",
  "common.open": "Åpne",
  "common.opened": "Åpen",
  "common.operation": "NEEDS TRANSLATION",
  "common.organization": "Bedrift",
  "common.organization-name": "Bedriftsnavn",
  "common.organization-number": "NEEDS TRANSLATION",
  "common.other": "Annet",
  "common.other-work": "Annet arbeid",
  "common.overtime": "Overtid",
  "common.paper": "NEEDS TRANSLATION",
  "common.password": "Passord",
  "common.pause": "Pause",
  "common.pending": "NEEDS TRANSLATION",
  "common.perks": "Fordeler",
  "common.phone": "Telefon",
  "common.phone-number": "Telefonnummer",
  "common.phone-prefix": "Landskode",
  "common.post-code": "NEEDS TRANSLATION",
  "common.postal-code": "Postnummer",
  "common.price-per-month": "NEEDS TRANSLATION",
  "common.print": "Skriv ut",
  "common.range": "Område",
  "common.reason": "Årsak",
  "common.reg-nr": "Reg.nr.",
  "common.register": "Registrer",
  "common.required": "Påkrevd",
  "common.responsible": "Ansvarlig",
  "common.rest": "Hvile",
  "common.restore": "Gjenopprett",
  "common.role": "Rolle",
  "common.save": "NEEDS TRANSLATION",
  "common.save-changes": "Lagre Endringer",
  "common.saving": "Lagrer",
  "common.school": "NEEDS TRANSLATION",
  "common.school-grade": "NEEDS TRANSLATION",
  "common.search": "Søk ...",
  "common.second-grade": "NEEDS TRANSLATION",
  "common.select-placeholder": "Gjør et valg",
  "common.settings": "NEEDS TRANSLATION",
  "common.sex": "NEEDS TRANSLATION",
  "common.share": "NEEDS TRANSLATION",
  "common.shortcuts": "Snarveier",
  "common.show-all": "Vis alle",
  "common.single-user": "Enkeltbruker",
  "common.sms": "SMS",
  "common.start": "Start",
  "common.status": "Status",
  "common.street": "NEEDS TRANSLATION",
  "common.subject": "Emne",
  "common.submit": "Send inn",
  "common.subscription": "NEEDS TRANSLATION",
  "common.subscriptions": "Abonnoment",
  "common.sum": "Sum",
  "common.terminal": "Terminal",
  "common.the-email": "E-posten",
  "common.theme": "NEEDS TRANSLATION",
  "common.thread": "Tråd",
  "common.time-entries": "Timeliste",
  "common.timesinceposted": "Tid siden lagt ut",
  "common.title": "Tittel",
  "common.unfavourite": "NEEDS TRANSLATION",
  "common.update": "Oppdater",
  "common.update-entry": "Endre innlegg",
  "common.update-folder": "Endre mappe",
  "common.updating": "Oppdaterer",
  "common.uploaded-attachments": "Opplastede tillegg",
  "common.user": "Bruker",
  "common.user-types": "Brukertyper",
  "common.userType": "Brukertype",
  "common.username": "Brukernavn",
  "common.users": "Brukere",
  "common.vehicle": "Kjøretøy",
  "common.week": "Uke",
  "common.weeks": "{weeks, plural, =0 {Ingen uker} one {# uke} other {# uker}}",
  "common.welcome": "Velkommen",
  "common.work": "Arbeid",
  "common.year": "År",
  "common.yearly": "NEEDS TRANSLATION",
  "common.yes": "Ja",
  "common.zip-code": "NEEDS TRANSLATION",
  "components.language-select.option-label": "NEEDS TRANSLATION",
  "confirm-reset-password.back-to-login": "NEEDS TRANSLATION",
  "confirm-reset-password.title": "NEEDS TRANSLATION",
  "copy.success": "NEEDS TRANSLATION",
  "createUser.title": "Opprett ny bruker",
  "dashboard.add-user": "NEEDS TRANSLATION",
  "dashboard.lastForumPosts": "Siste innlegg",
  "dashboard.register-hours": "Registrér timer",
  "dashboard.subscription-expiring-banner.title": "NEEDS TRANSLATION",
  "dashboard.welcome-text-my-worksheets":
    "Her vil du få en oversikt over dine arbeidsark. Du har enda ikke opprettet noen.",
  "dashboard.welcome-text-one":
    "Nyttig informasjon vil vises her etter du har opprettet et arbeidsark.",
  "dashboard.welcome-text-two":
    "Opprett et nytt arbeidsark ved å trykke på knappen nedenfor.",
  "document.files-for-document": "Filer tilhørende {name}",
  "documentation.documentation-for-control": "Dokumentasjon for kontroll",
  "documentation.drive-and-rest-time": "Kjøre og hviletid",
  "documents.documents-to-user": "Dokumentene til {user}",
  "documents.expiration-date": "Utløpsdato",
  "documents.name-on-document": "Navn på dokument",
  "documents.notification-time": "Tid for varsling",
  "documents.number-id": "Nummer/ID",
  "documents.responsible-user": "Ansvarsperson",
  "documents.show-files": "Vis filer",
  "documents.upload-document": "Last opp dokument",
  "documents.view-file": "Vis fil",
  "error.address-required": "Adresse er påkrevd",
  "error.categories": "Kunne ikke hente kategorier",
  "error.city-required": "By er påkrevd",
  "error.contact-person-phone-required":
    "Telefonnummer til kontaktperson er påkrevd",
  "error.contact-person-required": "Navn på kontaktperson er påkrevd",
  "error.could-not-change-profile-information":
    "Kunne ikke endre profilinformasjon",
  "error.could-not-check-in": "Kunne ikke sjekke inn",
  "error.could-not-check-out": "Kunne ikke sjekke ut",
  "error.could-not-create-type": "Kunne ikke lage {type}",
  "error.could-not-edit-type": "Kunne ikke endre {type}",
  "error.could-not-find-data": "Kunne ikke finne tabelldata",
  "error.could-not-read-file": "Kunne ikke lese fil",
  "error.create-issue": "Kunne ikke lage avvik",
  "error.field-is-required": "{field} er påkrevd",
  "error.files.could-not-read": "Kunne ikke lese fil",
  "error.first-name-required": "Fornavn er påkrevd",
  "error.generic": "Det har skjedd en feil",
  "error.generic-server-error":
    "Noe gikk galt på tjeneren. Vennligst prøv igjen.",
  "error.internal-number-required": "Internummer er påkrevd",
  "error.invalid-file-type": "Ugyldig filtype",
  "error.invalid-value": "Ugyldig verdi",
  "error.last-name-required": "Etternavn er påkrevd",
  "error.name-exists": "Det finnes allerede et innlegg med dette navnet",
  "error.need-organization-name": "Firmanavn må være fylt ut",
  "error.no-empty-fields": "NEEDS TRANSLATION",
  "error.no-first-name": "Mangler fornavn",
  "error.no-valid-fields": "NEEDS TRANSLATION",
  "error.phone-number-required": "Telefonnummer er påkrevd",
  "error.postal-code-required": "Postnummer er påkrevd",
  "error.type-already-exist": "{type} eksisterer allerede",
  "error.update-issue": "Kunne ikke oppdatere avvik",
  "error.users-already-exist": "NEEDS TRANSLATION",
  "error.valid-email-required": "Gyldig emailadresse er påkrevd",
  "error.wrong-username-or-password": "Feil brukernavn eller passord",
  "errors.change-password-weak": "Passordet er for svakt",
  "errors.common.name-already-exists": "Navnet eksisterer allerede",
  "errors.defaults.does-not-exist": "Objektet eksisterer ikke",
  "errors.defaults.foreign-key-constraint":
    "Objektet refererer til noe som ikke eksisterer",
  "errors.defaults.invalid-value": "En av de oppgitte verdiene var ugyldig",
  "errors.defaults.not-permitted":
    "Brukeren din har ikke tilgang til å gjøre dette",
  "errors.defaults.unique-constraint": "Objektet må være unikt",
  "errors.from-code.bad-input": "NEEDS TRANSLATION",
  "errors.from-code.configuration-not-found": "NEEDS TRANSLATION",
  "errors.from-code.crossword-computation-failed": "NEEDS TRANSLATION",
  "errors.from-code.crossword-computation-timed-out": "NEEDS TRANSLATION",
  "errors.from-code.crossword-word-too-large": "NEEDS TRANSLATION",
  "errors.from-code.division-calculation-timed-out": "NEEDS TRANSLATION",
  "errors.from-code.division-cannot-fit-half-page-grid-size":
    "NEEDS TRANSLATION",
  "errors.from-code.division-layout-undeterminable": "NEEDS TRANSLATION",
  "errors.from-code.email-already-taken": "NEEDS TRANSLATION",
  "errors.from-code.incorrect-password": "NEEDS TRANSLATION",
  "errors.from-code.internal-error": "NEEDS TRANSLATION",
  "errors.from-code.invalid-credentials": "NEEDS TRANSLATION",
  "errors.from-code.language-category-not-defined": "NEEDS TRANSLATION",
  "errors.from-code.language-not-supported": "NEEDS TRANSLATION",
  "errors.from-code.mathematics-not-allowed-for-wordlist-deduction":
    "NEEDS TRANSLATION",
  "errors.from-code.no-allowed-modules": "NEEDS TRANSLATION",
  "errors.from-code.not-found": "NEEDS TRANSLATION",
  "errors.from-code.organization-name-already-taken": "NEEDS TRANSLATION",
  "errors.from-code.readingtext-only-full-layout": "NEEDS TRANSLATION",
  "errors.from-code.readingtexts-no-content-available": "NEEDS TRANSLATION",
  "errors.from-code.readingtexts-no-data-available": "NEEDS TRANSLATION",
  "errors.from-code.remote-stripe-error": "NEEDS TRANSLATION",
  "errors.from-code.stripe-customer-not-found": "NEEDS TRANSLATION",
  "errors.from-code.unauthenticated": "NEEDS TRANSLATION",
  "errors.from-code.unauthorized": "NEEDS TRANSLATION",
  "errors.from-code.unknown": "NEEDS TRANSLATION",
  "errors.from-code.wordlist-too-small": "NEEDS TRANSLATION",
  "errors.from-code.wordsearch-computation-failed": "NEEDS TRANSLATION",
  "errors.from-code.wordsearch-computation-timed-out": "NEEDS TRANSLATION",
  "errors.from-code.wordsearch-word-too-large": "NEEDS TRANSLATION",
  "errors.generic-error": "Noe har gått galt",
  "errors.generic-not-empty-field": "NEEDS TRANSLATION",
  "errors.invalid": "Ugyldig",
  "errors.invalid-email-address": "E-post er ugyldig",
  "errors.invalid-email-fields": "NEEDS TRANSLATION",
  "errors.invalid-phone-number": "Ugyldig telefonnummer",
  "errors.max-value-reached": "NEEDS TRANSLATION",
  "errors.min-value-reached": "NEEDS TRANSLATION",
  "errors.must-be-number": "NEEDS TRANSLATION",
  "errors.passwords-do-not-match": "Passordene er ikke like",
  "errors.passwords-not-equal": "NEEDS TRANSLATION",
  "errors.reload-page": "NEEDS TRANSLATION",
  "errors.users.could-not-change-password": "Kunne ikke bytte passord",
  "errors.worksheets.readingtexts-need-full-layout": "NEEDS TRANSLATION",
  "existing-school-waiting-acceptance.description": "NEEDS TRANSLATION",
  "existing-school-waiting-acceptance.title": "NEEDS TRANSLATION",
  "existing-school-waiting-acceptance.toast": "NEEDS TRANSLATION",
  "feide-missing-email.submit": "NEEDS TRANSLATION",
  "feide-missing-email.subtitle": "NEEDS TRANSLATION",
  "feide-missing-email.title": "NEEDS TRANSLATION",
  "files.drop-to-upload": "Dropp filer her for å laste dem opp",
  "files.file-too-large":
    "Filen {name} er større enn maksimal størrelse på {max}MB.",
  "files.upload-files-here": "Last opp filer her",
  "forgotten-password.forgotten": "Glemt passordet?",
  "forgotten-password.go-back": "Tilbake til innlogging",
  "forgotten-password.success":
    "Hvis kontoen din finnes, er en e-post på vei med instruksjoner for tilbakestilling av passord.",
  "forgotten-password.success-message": "NEEDS TRANSLATION",
  "forgotten-password.title": "NEEDS TRANSLATION",
  "forgotten-password.title-success": "NEEDS TRANSLATION",
  "handbook.add_sub_folder": "Add sub folder",
  "handbook.create-entry-success": "Innlegg opprettet",
  "handbook.create-folder-success": "Opprettet mappe",
  "handbook.create_entry": "Lag nytt innlegg",
  "handbook.edit_folder": "Edit folder",
  "handbook.entry-load-error": "Feil ved innlasting av innlegg",
  "handbook.entry.delete-success": "Slettet innlegg",
  "handbook.folder-load-error": "Feil ved innlasting av mappe",
  "handbook.folder.delete-success": "Slettet mappe",
  "handbook.search": "Søk i håndboken",
  "handbook.start": "Start",
  "handbook.update-entry-success": "Innlegget ble oppdatert",
  "handbook.update-folder-success": "Mappen ble oppdatert",
  "institution.add-more-users": "NEEDS TRANSLATION",
  "institution.back-to-users": "NEEDS TRANSLATION",
  "institution.invitation-sent": "NEEDS TRANSLATION",
  "institution.invitations-sent": "NEEDS TRANSLATION",
  "institution.invite-users": "NEEDS TRANSLATION",
  "institution.send-invitation": "NEEDS TRANSLATION",
  "institution.update-success": "NEEDS TRANSLATION",
  "institutions.sent-invitations": "NEEDS TRANSLATION",
  "login.already-registered": "NEEDS TRANSLATION",
  "login.create-user": "Opprett bruker",
  "login.create-user-error": "Kunne ikke opprette bruker",
  "login.email-address-already-in-use": "E-post er opptatt",
  "login.forgotten-password": "NEEDS TRANSLATION",
  "login.not-already-registered": "NEEDS TRANSLATION",
  "login.organization-number-already-in-use": "NEEDS TRANSLATION",
  "login.password": "Passord",
  "login.repeat-password": "Gjenta passord",
  "modal.and-all-its-content": " og alt den inneholder",
  "modal.delete-attachment": 'Ønsker du å slette "{title}" fra tilleggene?',
  "modal.delete-attachment-title": "Slette tillegg",
  "modal.delete-folder": "Slette mappe",
  "modal.delete-folder-description":
    'Ønsker du å slette mappen "{title}" og alt innholdet?',
  "modal.delete-folder-entry-description":
    'Ønsker du å slette innlegget "{title}"?',
  "modal.delete-folder-entry-title": "Slette innlegg",
  "modal.delete-folder-title": "Slette mappen",
  "modal.delete-type": "Er du sikker på at du ønsker å slette {type}",
  "modal.delete-type-description":
    "Er du sikker på at du ønsker å slette {type}?",
  "modal.delete-type-title": "Slette {type}",
  "modal.remove-attachment": 'Ønsker du å fjerne "{title}" fra tilleggslisten?',
  "modal.remove-attachment-title": "Fjerne tillegg",
  "new-school-awaiting-confirmation.description": "NEEDS TRANSLATION",
  "new-school-awaiting-confirmation.title": "NEEDS TRANSLATION",
  "new-school-awaiting-confirmation.toast": "NEEDS TRANSLATION",
  "new-subscription-required.description": "NEEDS TRANSLATION",
  "new-subscription-required.title": "NEEDS TRANSLATION",
  "notifications.go-to-document": "Gå til dokument",
  "notifications.go-to-thread": "Gå til tråd",
  "operations.addition": "NEEDS TRANSLATION",
  "operations.division": "NEEDS TRANSLATION",
  "operations.multiplication": "NEEDS TRANSLATION",
  "operations.subtraction": "NEEDS TRANSLATION",
  "pay-for-subscription.purchase": "NEEDS TRANSLATION",
  "pay-for-subscription.title": "NEEDS TRANSLATION",
  "payment-success.description":
    "Abonnementet ditt vil begynne å løpe umiddelbart.",
  "payment-success.title": "Suksess!",
  "payment-success.toast": "Betalingen ble gjennomført",
  "permissions.add": "Opprette",
  "permissions.change": "Endre",
  "permissions.change_sticky": "Endre festet tråd",
  "permissions.forum-send-email": "Sende e-post",
  "permissions.forum-send-sms": "Sende SMS",
  "permissions.no-access-to-page":
    "Brukeren din har ikke tilgang til denne siden",
  "permissions.organization-settings-general": "Generelt",
  "permissions.remove": "Slette",
  "permissions.view": "Se",
  "permissions.view-and-change": "Se/Endre",
  "register-organization.billing-email": "NEEDS TRANSLATION",
  "register-organization.title": "NEEDS TRANSLATION",
  "register-school.choose-method.existing-school": "NEEDS TRANSLATION",
  "register-school.choose-method.new-school": "NEEDS TRANSLATION",
  "register-school.choose-method.title": "NEEDS TRANSLATION",
  "register-school.chosen-school": "NEEDS TRANSLATION",
  "register-school.create-user-and-join-school": "NEEDS TRANSLATION",
  "register-school.create-user-and-school": "NEEDS TRANSLATION",
  "register-school.search-for-school": "NEEDS TRANSLATION",
  "register-school.title": "NEEDS TRANSLATION",
  "register-user.description":
    "Siden dette er første gang du logger inn må du fylle ut noe standard informasjon.",
  "register-user.title": "Fyll inn personalia",
  "register.already-registered": "NEEDS TRANSLATION",
  "register.bad-token-title": "NEEDS TRANSLATION",
  "register.complete-registration": "NEEDS TRANSLATION",
  "register.errors.bad-token": "NEEDS TRANSLATION",
  "register.errors.expired-token": "NEEDS TRANSLATION",
  "register.expired-token-title": "NEEDS TRANSLATION",
  "register.registration-complete": "NEEDS TRANSLATION",
  "register.to-login": "NEEDS TRANSLATION",
  "register.verified-message": "NEEDS TRANSLATION",
  "register.verified-title": "NEEDS TRANSLATION",
  "register.verify-email-message": "NEEDS TRANSLATION",
  "register.verify-email-title": "NEEDS TRANSLATION",
  "reset-password.errors.bad-token": "Nøkkelen er ugyldig",
  "reset-password.errors.expired-token":
    "Tilbakestillingsnøkkelen har gått ut på dato.",
  "reset-password.go-back": "NEEDS TRANSLATION",
  "reset-password.message": "NEEDS TRANSLATION",
  "reset-password.submit": "NEEDS TRANSLATION",
  "reset-password.success": "NEEDS TRANSLATION",
  "reset-password.title": "Tilbakestill passordet ditt",
  "school-grades.fifth": "NEEDS TRANSLATION",
  "school-grades.first": "NEEDS TRANSLATION",
  "school-grades.fourth": "NEEDS TRANSLATION",
  "school-grades.second": "NEEDS TRANSLATION",
  "school-grades.seventh": "NEEDS TRANSLATION",
  "school-grades.sixth": "NEEDS TRANSLATION",
  "school-grades.third": "NEEDS TRANSLATION",
  "select-multiple.deselect-all": "NEEDS TRANSLATION",
  "select-multiple.multiple-selected": "NEEDS TRANSLATION",
  "select-multiple.select-all": "NEEDS TRANSLATION",
  "select-sex.label.female": "NEEDS TRANSLATION",
  "select-sex.label.male": "NEEDS TRANSLATION",
  "select-sex.label.rather-not-say": "NEEDS TRANSLATION",
  "select-subscription.title": "NEEDS TRANSLATION",
  "select-user-setting.description":
    "Denne skjermen lar deg velge hvilke brukertyper som skal dukke opp i nedtrekksmenyen på visse sider. Alle brukere med minst en av brukertypene som er valgt vil komme opp i de nedtrekksmenyene.",
  "select-user-settings.title": "Bruker dropdown innstillinger",
  "selectOrganization.select": "Velg firma",
  "settings.add-absence-type": "Legg til fraværstype",
  "settings.add-issue-category": "Legg til avvikskategori",
  "settings.add-new-terminal": "Legg til ny terminal",
  "settings.added-issue-category": "La til ny avvikskategori",
  "settings.admin-paper-option": "NEEDS TRANSLATION",
  "settings.billing.billing-email": "NEEDS TRANSLATION",
  "settings.billing.title": "NEEDS TRANSLATION",
  "settings.change-logo": "Last opp ny logo",
  "settings.class": "Klassetrinn",
  "settings.current-password": "NEEDS TRANSLATION",
  "settings.edit-type-settings": "Endre {type}innstillinger",
  "settings.errors.change-language": "NEEDS TRANSLATION",
  "settings.information": "Opplysninger",
  "settings.labels.billing-method": "NEEDS TRANSLATION",
  "settings.my-settings": "Mine Innstillinger",
  "settings.new-password": "NEEDS TRANSLATION",
  "settings.organization-logo": "Bedriftslogo",
  "settings.organization-settings": "Bedriftsinnstillinger",
  "settings.personal-information": "Personlige opplysninger",
  "settings.repeat-new-password": "NEEDS TRANSLATION",
  "settings.save-changes": "Lagre endringer",
  "settings.save-settings": "Lagre innstillinger",
  "settings.saved-successfully": "NEEDS TRANSLATION",
  "settings.tabs.billing": "NEEDS TRANSLATION",
  "settings.tabs.change-password": "NEEDS TRANSLATION",
  "settings.tabs.information": "NEEDS TRANSLATION",
  "settings.toasts.change-language-success": "NEEDS TRANSLATION",
  "settings.toasts.password-changed-successfully": "NEEDS TRANSLATION",
  "settings.tv-view": "Vis på TV",
  "settings.updated-type": "Oppdaterte {type}",
  "settings.updated-userinfo": "Oppdatert brukerinfo!",
  "settings.upload": "Last opp",
  "settings.upload-type": "Last opp {type}",
  "settings.which-class-are-you-teaching": "Hvilket trinn underviser du for?",
  "settings.work-place": "Arbeidsplass",
  "setup-success.description": "NEEDS TRANSLATION",
  "setup-success.success": "NEEDS TRANSLATION",
  "setup-success.title": "NEEDS TRANSLATION",
  "share-link-modal.ingress": "NEEDS TRANSLATION",
  "share-link-modal.title": "NEEDS TRANSLATION",
  "single-user-email-confirmation.button-with-count": "NEEDS TRANSLATION",
  "single-user-email-confirmation.button-without-count": "NEEDS TRANSLATION",
  "single-user-email-confirmation.description": "NEEDS TRANSLATION",
  "single-user-email-confirmation.new-email-sent": "NEEDS TRANSLATION",
  "single-user-email-confirmation.title": "NEEDS TRANSLATION",
  "single-user-email-confirmation.toast": "NEEDS TRANSLATION",
  "subscription-cancelled.buy-new": "NEEDS TRANSLATION",
  "subscription-cancelled.title": "NEEDS TRANSLATION",
  "subscription-cancelled.you-have-access-to": "NEEDS TRANSLATION",
  "subscription-personal.cancel": "NEEDS TRANSLATION",
  "subscription-personal.has-payment-method-text": "NEEDS TRANSLATION",
  "subscription-personal.price": "NEEDS TRANSLATION",
  "subscription-personal.reactivate": "NEEDS TRANSLATION",
  "subscription-personal.reactivate-confirm": "NEEDS TRANSLATION",
  "subscription-personal.regular-button": "NEEDS TRANSLATION",
  "subscription-personal.regular-subtitle": "NEEDS TRANSLATION",
  "subscription-personal.regular-title": "NEEDS TRANSLATION",
  "subscription-personal.trial-button": "NEEDS TRANSLATION",
  "subscription-personal.trial-info": "NEEDS TRANSLATION",
  "subscription-personal.trial-subtitle": "NEEDS TRANSLATION",
  "subscription-personal.trial-title": "NEEDS TRANSLATION",
  "subscription-personal.will-cancel": "NEEDS TRANSLATION",
  "subscription-personal.will-cancel-subtitle": "NEEDS TRANSLATION",
  "subscription-school-cancelled.reactivate-subscription": "NEEDS TRANSLATION",
  "subscription-school-cancelled.subtitle": "NEEDS TRANSLATION",
  "subscription-school-cancelled.toast.success": "NEEDS TRANSLATION",
  "subscription-school-member.description": "NEEDS TRANSLATION",
  "subscription-school.active.edit-billing-info": "NEEDS TRANSLATION",
  "subscription-school.active.will-be-billed-at": "NEEDS TRANSLATION",
  "subscription-school.cancel.confirm-cancel": "NEEDS TRANSLATION",
  "subscription-school.cancel.keep-subscription": "NEEDS TRANSLATION",
  "subscription-school.cancel.last-access-info": "NEEDS TRANSLATION",
  "subscription-school.cancel.title": "NEEDS TRANSLATION",
  "subscription-school.cancel.toast-text": "NEEDS TRANSLATION",
  "subscription-school.no-subscription.buttonText": "NEEDS TRANSLATION",
  "subscription-school.no-subscription.disclaimer": "NEEDS TRANSLATION",
  "subscription-school.no-subscription.title": "NEEDS TRANSLATION",
  "subscription-school.no-subscription.toast.success": "NEEDS TRANSLATION",
  "subscription-school.trial.activate": "NEEDS TRANSLATION",
  "subscription-school.trial.active-description": "NEEDS TRANSLATION",
  "subscription-school.trial.deactivate": "NEEDS TRANSLATION",
  "subscription-school.trial.subtitle": "NEEDS TRANSLATION",
  "subscription-school.trial.title": "NEEDS TRANSLATION",
  "subscription-will-cancel.modal.title": "NEEDS TRANSLATION",
  "subscriptions.cancel-subscription": "NEEDS TRANSLATION",
  "subscriptions.change-periodicity": "NEEDS TRANSLATION",
  "subscriptions.current-subscription": "NEEDS TRANSLATION",
  "subscriptions.try-for-free-30-days": "Prøv Arbeidsark gratis",
  "table.week-sum": "Ukesum",
  "terminal.check-in": "Sjekk inn",
  "terminal.check-out": "Sjekk ut",
  "terminal.checked-in": "Sjekket inn",
  "terminal.checked-in-at": "Sjekket inn kl. {time}",
  "terminal.checked-in-message":
    "Du sjekket inn {checkIn} og har arbeidet {total} timer",
  "terminal.checked-out": "Sjekket ut",
  "terminal.checked-out-at": "Sjekket ut kl. {time}",
  "terminal.ip-address": "IP adresse",
  "terminal.ip-filter-range": "IP filterområde",
  "terminal.no-activity-period":
    "Du har ikke noe registrert aktivitet for valgt periode",
  "terminal.no-activity-today": "Du har ikke registrert noen aktivitet i dag.",
  "terminal.not-on-network":
    "Du må være på et terminalnettverk for å sjekke ut eller inn",
  "terminal.terminal-areas": "Terminalområder",
  "terminal.terminal-name": "Terminalnavn",
  "terminal.time": "Tid",
  "terminal.user-activity": "Aktiviteten til {user}",
  "terminal.user-no-activity-period":
    "{user} har ikke noe registrert aktivetet for valgt periode",
  "terminal.your-activity": "Din aktivitet",
  "terminal.your-activity-today": "Din aktivitet i dag",
  "thread.success-creation": "Opprettet ny tråd",
  "timesheets.absence-create-type": "Opprett ny fraværstype",
  "timesheets.absence-type": "Fraværstype",
  "timesheets.absence-type-name": "Fraværstypenavn",
  "timesheets.absence-types": "Fraværstyper",
  "timesheets.absence-types-error-1":
    "Fravær kan ikke bli lagt til mer enn én gang per dag per ansatt.",
  "timesheets.error-registration-absence":
    "Feil ved registrering av nytt fravær",
  "timesheets.error-registration-timeentry":
    "Feil ved registrering av nye timer",
  "timesheets.error-update-absence": "Feil ved oppdatering av fravær",
  "timesheets.error-update-timeentry": "Feil ved oppdatering av timer",
  "timesheets.note": "Notat",
  "timesheets.register-absence": "Registrer fravær",
  "timesheets.register-timeentry": "Registrer nye timer",
  "timesheets.success-registration-absence": "Nytt fravær registrert",
  "timesheets.success-registration-timeentry": "Nye timer registrert",
  "timesheets.success-update-absence": "Fravær oppdatert",
  "timesheets.success-update-timeentry": "Timer oppdatert",
  "timesheets.update-absence": "Oppdater fravær",
  "timesheets.update-timeentry": "Oppdater timer",
  "timesheets.view-all-absence": "Alt fravær",
  "timesheets.view-all-timeentries": "Alles timer",
  "timesheets.view-your-absence": "Ditt fravær",
  "timesheets.view-your-timeentries": "Dine timer",
  "toasts.error": "Feil",
  "toasts.error-add-type": "Kunne ikke legge til {type}",
  "toasts.error-delete-type": "Kunne ikke slette {type}",
  "toasts.error-update-type": "Kunne ikke oppdatere {type}",
  "toasts.error.upload-type": "Kunne ikke laste opp {type}",
  "toasts.info": "Info",
  "toasts.success": "Suksess",
  "toasts.success-add-type": "La til ny {type}",
  "toasts.success-delete-type": "Slettet {type}",
  "toasts.success-update-type": "Oppdaterte {type}",
  "toasts.success.upload-type": "Lastet opp {type}",
  "toasts.warning": "Advarsel",
  "user-type-settings.delete-prompt-text":
    "Er du sikker på at du vil slette brukertypen?",
  "user-type-settings.delete-prompt-title": "Slett brukertype",
  "user-type-settings.description":
    "På denne siden kan du endre brukertyper og tilganger.",
  "user-type-settings.description-2":
    'Merk at alle endringer under "Endre" og "Slette" gir deg tilgang til å endre og slette ressurser opprettet av andre. Alle som har tilgang til å lage en ressurs har også tilgang til å endre sine egne ressurser.',
  "user-type-settings.title": "Brukertyper og tilganger",
  "user-type-settings.toasts.error": "Feil ved oppdatering",
  "user-type-settings.toasts.success": "Oppdaterte brukertyper",
  "user-types.change-settings-label": "Endre",
  "user-types.create-settings-label": "Opprette",
  "user-types.driver-activities-self": "Kjøredata (egen)",
  "user-types.everyones-driver-activities": "Kjøredata (alles)",
  "user-types.remove-settings-label": "Slette",
  "user-types.view-settings-label": "Se",
  "users.accept-user-join-request": "NEEDS TRANSLATION",
  "users.activated-user": "NEEDS TRANSLATION",
  "users.active": "Aktiv",
  "users.add-user": "Legg til bruker",
  "users.admin-password-reset-success": "NEEDS TRANSLATION",
  "users.bio": "Profilbiografi",
  "users.birth-number": "Fødselsnummer",
  "users.change-picture": "Endre bilde",
  "users.change-profile-picture": "Endre bilde",
  "users.class": "klasse",
  "users.contact-person-name": "Kontaktperson navn",
  "users.contact-person-phone": "Kontaktperson telefon",
  "users.deactivated-user": "NEEDS TRANSLATION",
  "users.driver-card-number": "Sjåførkort",
  "users.edit-profile": "Redigér profil",
  "users.edit-profile-information": "Redigér profilinformasjonen",
  "users.edit-user": "Redigér bruker",
  "users.grade": "Klassetrinn",
  "users.has-no-organizations":
    "Du er ikke assosiert med noen firmaer. Vennligst ta kontakt med administatoren din.",
  "users.inactive": "Inaktiv",
  "users.internal-number": "Internnummer",
  "users.my-profile": "Min Profil",
  "users.new": "Ny bruker",
  "users.personal-info": "Personlig informasjon",
  "users.profile": "Profil",
  "users.reject-user-join-request": "NEEDS TRANSLATION",
  "users.remove-user-from-organization": "NEEDS TRANSLATION",
  "users.reset-password": "NEEDS TRANSLATION",
  "users.reset-password-email-sent-by-admin": "NEEDS TRANSLATION",
  "users.search": "Søk etter bruker",
  "users.settings": "Mine innstillinger",
  "users.user-activated": "NEEDS TRANSLATION",
  "users.user-deactivated": "NEEDS TRANSLATION",
  "users.user-removed-success": "NEEDS TRANSLATION",
  "validation.no-white-space-end": "NEEDS TRANSLATION",
  "warnings.worksheets.arithmetic-operation-might-not-be-supported-for-grade":
    "NEEDS TRANSLATION",
  "warnings.worksheets.task-type-not-supported-for-grade": "NEEDS TRANSLATION",
  "worksheets.arithmetic-detail-modal.set-lowest-highest": "NEEDS TRANSLATION",
  "worksheets.buttons.generate-worksheet": "NEEDS TRANSLATION",
  "worksheets.buttons.regenerate": "NEEDS TRANSLATION",
  "worksheets.buttons.hide-options": "NEEDS TRANSLATION",
  "worksheets.buttons.show-options": "NEEDS TRANSLATION",
  "worksheets.delete-success": "NEEDS TRANSLATION",
  "worksheets.grade-groups.fiveToSeven": "NEEDS TRANSLATION",
  "worksheets.grade-groups.oneToFour": "NEEDS TRANSLATION",
  "worksheets.labels.arithmetic-operation": "NEEDS TRANSLATION",
  "worksheets.labels.configure": "NEEDS TRANSLATION",
  "worksheets.labels.grade": "NEEDS TRANSLATION",
  "worksheets.labels.language-theme": "NEEDS TRANSLATION",
  "worksheets.labels.math-module": "NEEDS TRANSLATION",
  "worksheets.labels.name": "NEEDS TRANSLATION",
  "worksheets.labels.number-of-pages": "NEEDS TRANSLATION",
  "worksheets.labels.page": "NEEDS TRANSLATION",
  "worksheets.labels.page-layout": "NEEDS TRANSLATION",
  "worksheets.labels.random": "NEEDS TRANSLATION",
  "worksheets.labels.random-plural": "NEEDS TRANSLATION",
  "worksheets.labels.select-task-types": "NEEDS TRANSLATION",
  "worksheets.labels.select-theme": "NEEDS TRANSLATION",
  "worksheets.labels.task": "NEEDS TRANSLATION",
  "worksheets.labels.theme": "NEEDS TRANSLATION",
  "worksheets.language-theme.birds": "NEEDS TRANSLATION",
  "worksheets.language-theme.bugs": "NEEDS TRANSLATION",
  "worksheets.language-theme.christmas": "NEEDS TRANSLATION",
  "worksheets.language-theme.clothes": "NEEDS TRANSLATION",
  "worksheets.language-theme.colours": "NEEDS TRANSLATION",
  "worksheets.language-theme.farm-animals": "NEEDS TRANSLATION",
  "worksheets.language-theme.forest-animals": "NEEDS TRANSLATION",
  "worksheets.language-theme.fruits-and-berries": "NEEDS TRANSLATION",
  "worksheets.language-theme.months": "NEEDS TRANSLATION",
  "worksheets.language-theme.my-family": "NEEDS TRANSLATION",
  "worksheets.language-theme.my-house": "NEEDS TRANSLATION",
  "worksheets.language-theme.space": "NEEDS TRANSLATION",
  "worksheets.language-theme.the-body-external": "NEEDS TRANSLATION",
  "worksheets.language-theme.the-body-internal": "NEEDS TRANSLATION",
  "worksheets.language-theme.vegetables": "NEEDS TRANSLATION",
  "worksheets.language-theme.water-seashore": "NEEDS TRANSLATION",
  "worksheets.language-theme.weather-and-seasons": "NEEDS TRANSLATION",
  "worksheets.language-theme.weekdays": "NEEDS TRANSLATION",
  "worksheets.options.arithmetic-operation": "NEEDS TRANSLATION",
  "worksheets.options.math-module":
    "{module, select, arithmeticAlgorithms {Algoritmer aritmetikk} arithmeticSimple {Aritmetikk - Enkel} arithmeticFractionsSimple {Aritmetikk Brøk - Enkel} clockAnalogoue {Klokke - Analog} clockDigital {Klokke - Digital} guessTheHouse {Gjett huset} numberGrid {Tallruter} numberLines {Tallinje} numberPyramids {Tallpyramide} numberSequence {Tallsekvens} numberSort {Tallsortering} patterns {Tallmønstre} standardAlgorithm {Standard Algoritme} sudoku {Sudoku} random {Tilfeldige} other {Random}}",
  "worksheets.options.page-layout":
    "{pageLayout, select, ONE {En per side} ONEONE {En oppe, en nede} ONETWO {En oppe, to nede} TWOONE {To oppe, en nede} TWOTWO {To oppe, to nede} ONEONEONEONE {Fire rader med en hver} other {Andre}}",
  "worksheets.options.theme": "NEEDS TRANSLATION",
  "worksheets.page-layouts.full": "NEEDS TRANSLATION",
  "worksheets.page-layouts.half": "NEEDS TRANSLATION",
  "worksheets.search-placeholder": "Søk etter arbeidsark..",
  "worksheets.task-types.generic.crossword": "NEEDS TRANSLATION",
  "worksheets.task-types.generic.readingTexts": "NEEDS TRANSLATION",
  "worksheets.task-types.generic.wordSearch": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.arithemtic": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.arithmetic": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.grid": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.guessTheHouse": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.mathCrossBox": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.neighbourNumbers": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.numberPatterns": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.numberSeries": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.pyramid": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.sorting": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.standardAlgorithm": "NEEDS TRANSLATION",
  "worksheets.task-types.mathematics.sudoku": "NEEDS TRANSLATION",
  "worksheets.themes.17mai": "NEEDS TRANSLATION",
  "worksheets.themes.christmas": "NEEDS TRANSLATION",
  "worksheets.themes.halloween": "NEEDS TRANSLATION",
  "worksheets.themes.mermaids": "NEEDS TRANSLATION",
  "worksheets.themes.numberchars": "NEEDS TRANSLATION",
  "worksheets.themes.space": "NEEDS TRANSLATION",
  "worksheets.themes.tools": "Ark og blyant",
  "worksheets.themes.unicorn": "NEEDS TRANSLATION",
  "worksheets.title-placeholder": "NEEDS TRANSLATION",
  "worksheets.wordlist-modal.edit-words": "NEEDS TRANSLATION",
  "worksheets.worksheet-generator": "Arbeidsarkgenerator",

  // Onboarding Tour
  "onboarding.tour.welcome.title": "Velkomen til den nye generatoren!",
  "onboarding.tour.welcome.description":
    "Den nye arbeidsarkgeneratoren gir deg umiddelbar førehandsvisning av arbeidsarka medan du lagar dei. La oss ta ei rask omvising!",
  "onboarding.tour.preview.title": "Umiddelbar førehandsvisning",
  "onboarding.tour.preview.description":
    "Sjå arbeidsarket oppdaterast i sanntid medan du gjer endringar. Ikkje meir venting på at PDF-en skal genererast!",
  "onboarding.tour.tabs.title": "Byt fag",
  "onboarding.tour.tabs.description":
    "Vel mellom matematikk, norsk og engelsk arbeidsark ved å bruke desse fanene.",
  "onboarding.tour.settings.title": "Tilpass arbeidsarket ditt",
  "onboarding.tour.settings.description":
    "Set namn, klassetrinn, operasjonar, layout, oppgåvetypar og tema for arbeidsarket ditt her.",
  "onboarding.tour.pages.title": "Legg til sider",
  "onboarding.tour.pages.description":
    "Bruk + og - knappane for å leggje til eller fjerne sider frå arbeidsarket ditt. Prøv å klikke på + for å leggje til ei side!",
  "onboarding.tour.page-config.title": "Side-for-side redigering",
  "onboarding.tour.page-config.description":
    "Kvar side kan tilpassast individuelt. Klikk for å utvide og sjå alternativ for kvar oppgåve.",
  "onboarding.tour.configure.title": "Tilpass oppgåver",
  "onboarding.tour.configure.description":
    "Klikk på denne knappen for å tilpasse detaljane i ei spesifikk oppgåve, som vanskegrad eller talområde.",
  "onboarding.tour.module-regenerate.title": "Regenerer oppgåve",
  "onboarding.tour.module-regenerate.description":
    "Når du har endra konfigurasjon på ei oppgåve trykker du på denne knappen for å generere ho på nytt. Ingen andre oppgåver i arket ditt blir endra av dette.",
  "onboarding.tour.global-regenerate.title": "Regenerer heile arket",
  "onboarding.tour.global-regenerate.description":
    "Trykk her for å regenerere alle oppgåver på heile arbeidsarket med dei valde innstillingane.",
  "onboarding.tour.download.title": "Last ned PDF",
  "onboarding.tour.download.description":
    "Last ned arbeidsarket som ei PDF-fil for å skrive ut eller dele.",
  "onboarding.tour.save.title": "Lagre i biblioteket",
  "onboarding.tour.save.description":
    "Lagre arbeidsarket i biblioteket ditt for enkel tilgang seinare. Det blir også lasta ned automatisk.",
  "onboarding.tour.done.title": "Du er klar!",
  "onboarding.tour.done.description":
    "No kan du det grunnleggjande i den nye generatoren. Begynn å lage arbeidsarket ditt! Du kan ta omvisinga på nytt når som helst ved å klikke på hjelpeknappen.",
  "onboarding.tour.buttons.next": "Neste",
  "onboarding.tour.buttons.prev": "Førre",
  "onboarding.tour.buttons.done": "Kom i gang",
  "onboarding.tour.buttons.skip": "Hopp over",
  "onboarding.tour.help-button.tooltip": "Ta omvisinga",
}
export default nn
